module.exports = __webpack_public_path__ + "static/media/badges-level.07371ccf.svg";